import { ApartmentOutlined, FilterFilled, HomeFilled, LoadingOutlined, TeamOutlined } from '@ant-design/icons';
import { ConfigProvider, Layout, Menu, MenuProps, Row, Skeleton, Tabs, theme } from 'antd';
import VersionInfo from '../components/VersionInfo';
import { MAIN_SIDEBAR_WIDTH, MIN_WIDTH, TAB_BAR_HEIGHT } from '../styles/theme';

const items: MenuProps['items'] = [
    {
        key: '1',
        icon: <HomeFilled />
    },
    {
        key: '2',
        icon: <FilterFilled />
    },
    {
        key: '5',
        icon: <TeamOutlined />
    },
    {
        key: '3',
        icon: <ApartmentOutlined />
    },
    {
        key: '6',
        icon: <LoadingOutlined spin />
    },
    {
        key: '4',
        icon: <LoadingOutlined spin />
    }
];

const styles = { root: { height: '100vh', minWidth: MIN_WIDTH }, tab: { height: TAB_BAR_HEIGHT, margin: 0 } };

export default function LoadingLayout() {
    const {
        token: { colorWhite, colorPrimary, margin, paddingSM }
    } = theme.useToken();

    return (
        <Layout hasSider style={styles.root}>
            <ConfigProvider
                theme={{
                    token: {
                        colorTextBase: colorWhite,
                        colorBgBase: colorPrimary
                    }
                }}
            >
                <Layout.Sider collapsed collapsedWidth={MAIN_SIDEBAR_WIDTH} theme="light">
                    <Menu items={items} className="full-height" mode="inline" />
                    <VersionInfo loadingLayout />
                </Layout.Sider>
            </ConfigProvider>
            <Layout.Content>
                <Tabs animated={false} type="editable-card" items={[]} tabBarStyle={styles.tab} />
                <Row align="middle" justify="space-between" style={{ padding: paddingSM }}>
                    <Skeleton
                        active
                        paragraph={{ rows: 4 }}
                        style={{ marginBottom: margin }}
                        title={{ style: { display: 'inline-block' } }}
                    />
                    <Skeleton active paragraph={{ rows: 4 }} title={{ style: { display: 'inline-block' } }} />
                </Row>
            </Layout.Content>
        </Layout>
    );
}
